import { PassesList } from '@drycut/booking-components';
import { useDocumentTitle } from 'usehooks-ts';

export function Passes(): React.ReactElement {
  useDocumentTitle('DRYCUT - DRYPASS');

  return <PassesList />;
}
